/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMCPPlatformToolsetsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMCPPlatformToolsetsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMCPPlatformToolsetsSecurity = {
  option1?: ListMCPPlatformToolsetsSecurityOption1 | undefined;
  option2?: ListMCPPlatformToolsetsSecurityOption2 | undefined;
};

export type ListMCPPlatformToolsetsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMCPPlatformToolsetsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMCPPlatformToolsetsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListMCPPlatformToolsetsSecurityOption1$Outbound,
    ListMCPPlatformToolsetsSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listMCPPlatformToolsetsSecurityOption1ToJSON(
  listMCPPlatformToolsetsSecurityOption1:
    ListMCPPlatformToolsetsSecurityOption1,
): string {
  return JSON.stringify(
    ListMCPPlatformToolsetsSecurityOption1$outboundSchema.parse(
      listMCPPlatformToolsetsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMCPPlatformToolsetsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMCPPlatformToolsetsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListMCPPlatformToolsetsSecurityOption2$Outbound,
    ListMCPPlatformToolsetsSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listMCPPlatformToolsetsSecurityOption2ToJSON(
  listMCPPlatformToolsetsSecurityOption2:
    ListMCPPlatformToolsetsSecurityOption2,
): string {
  return JSON.stringify(
    ListMCPPlatformToolsetsSecurityOption2$outboundSchema.parse(
      listMCPPlatformToolsetsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMCPPlatformToolsetsSecurity$Outbound = {
  Option1?: ListMCPPlatformToolsetsSecurityOption1$Outbound | undefined;
  Option2?: ListMCPPlatformToolsetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMCPPlatformToolsetsSecurity$outboundSchema: z.ZodMiniType<
  ListMCPPlatformToolsetsSecurity$Outbound,
  ListMCPPlatformToolsetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMCPPlatformToolsetsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMCPPlatformToolsetsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMCPPlatformToolsetsSecurityToJSON(
  listMCPPlatformToolsetsSecurity: ListMCPPlatformToolsetsSecurity,
): string {
  return JSON.stringify(
    ListMCPPlatformToolsetsSecurity$outboundSchema.parse(
      listMCPPlatformToolsetsSecurity,
    ),
  );
}

/** @internal */
export type ListMCPPlatformToolsetsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMCPPlatformToolsetsRequest$outboundSchema: z.ZodMiniType<
  ListMCPPlatformToolsetsRequest$Outbound,
  ListMCPPlatformToolsetsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMCPPlatformToolsetsRequestToJSON(
  listMCPPlatformToolsetsRequest: ListMCPPlatformToolsetsRequest,
): string {
  return JSON.stringify(
    ListMCPPlatformToolsetsRequest$outboundSchema.parse(
      listMCPPlatformToolsetsRequest,
    ),
  );
}
